module.exports = __webpack_public_path__ + "fad0a4f27c7fe0b7656bea0af743a254.gif";